import { render } from "./BetaAccessButton.vue?vue&type=template&id=1a4515fa&scoped=true"
import script from "./BetaAccessButton.vue?vue&type=script&lang=js"
export * from "./BetaAccessButton.vue?vue&type=script&lang=js"

import "./BetaAccessButton.vue?vue&type=style&index=0&id=1a4515fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4515fa"]])

export default __exports__